export default __webpack_public_path__ + "static/media/la3.1.10305c2f.png";